import { toast } from 'sonner';

interface ErrorResponse {
  response?: {
    status?: number;
    data?: {
      errors?: string[];
      error?: string;
      message?: string;
    };
  };
  message?: string;
}
export const handleQueryError = (error: unknown, customMessage?: string) => {
  const err = error as ErrorResponse;
  if (err.response?.status === 422 && err.response?.data?.errors) {
    const errors = err.response.data.errors;
    toast.error('Validation Failed: ', {
      description: (
        <div className="space-y-1">
          {errors.map((error, index) => (
            <div key={index} className="text-sm">
              • {error}
            </div>
          ))}
        </div>
      ),
    });
    return;
  }

  if (err.response?.status === 404) {
    toast.error('Not Found', {
      description: 'The requested resource was not found.',
    });
    return;
  }

  if (err.response?.status && err.response.status >= 500) {
    toast.error('Server Error', {
      description: 'Something went wrong on our end. Please try again later.',
    });
    return;
  }

  if (err.response?.status === 401) {
    // This is already handled by Axios. Please refer to client.ts
    return;
  }
  toast.error(customMessage || 'Something went wrong. Please try again.');
};

export const handleDeleteError = (error: unknown, resourceName = 'item') => {
  const err = error as ErrorResponse;
  if (err.response?.status === 409) {
    toast.error(`Cannot delete ${resourceName}`, {
      description:
        err.response?.data?.error ||
        `This ${resourceName} has associated data and cannot be deleted.`,
    });
    return;
  }
  handleQueryError(error, `Failed to delete ${resourceName}. Please try again`);
};
